import React from "react";
import { Trans, useTranslation } from "react-i18next";
import "./CookiePolicy.scss";
import AppContainer from "../../components/app-container/AppContainer";
import { useDocumentTitle } from "../../components/title/DocumentTitle";

const CookiePolicy = () => {
    const { t } = useTranslation();

    useDocumentTitle(t("COOKIE_POLICY"));

    return (
        <>
            <AppContainer header={{ menuLoginEnabled: false }}>
                <div className={"cookie-policy-page"}>
                    <h1>{t("COOKIE_POLICY")}</h1>
                    <h2>{t("1_INTRODUCTION.HEADLINE")}</h2>

                    <section>
                        <p>
                            <Trans
                                i18nKey="1_INTRODUCTION.SECTION_1"
                                components={{
                                    link1: <a href="https://my.eos-spain.es/" />,
                                    link2: <a href="/services/content/privacyPolicy.html" />,
                                }}
                            />
                        </p>
                    </section>

                    <h2>{t("2_COOKIE_EXPLANATION.HEADLINE")}</h2>
                    <section>
                        <p>{t("2_COOKIE_EXPLANATION.SECTION_1")}</p>
                        <p>{t("2_COOKIE_EXPLANATION.SECTION_2")}</p>
                    </section>
                    <h2>{t("3_COOKIE_TYPES.HEADLINE")}</h2>

                    <section>
                        <p>{t("3_COOKIE_TYPES.SECTION_1")}</p>

                        <Trans i18nKey="3_COOKIE_TYPES.LIST" />
                        <p>{t("3_COOKIE_TYPES.SECTION_2")}</p>

                        <div className={"session-privacy-table-container"}>
                            <table className={"session-privacy-table"}>
                                <Trans i18nKey="3_COOKIE_TYPES.COOKIE_TABLE" />
                            </table>
                        </div>
                    </section>
                    <h2>{t("4_COOKIE_DURATION.HEADLINE")}</h2>

                    <section>
                        <p>{t("4_COOKIE_DURATION.SECTION_1")}</p>
                        <p>{t("4_COOKIE_DURATION.SECTION_2")}</p>
                        <p>{t("4_COOKIE_DURATION.SECTION_3")}</p>
                    </section>
                    <h2>{t("5_COOKIE_CONFIGURATION.HEADLINE")}</h2>

                    <section>
                        <p>{t("5_COOKIE_CONFIGURATION.SECTION_1")}</p>
                        <ul>
                            <li>
                                <a href="https://support.microsoft.com/en-us/windows/delete-and-manage-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank">
                                    • Internet Explorer
                                </a>
                            </li>
                            <li>
                                <a href="https://www.mozilla.org/en-US/privacy/websites/#cookies" target="_blank">
                                    • Firefox
                                </a>
                            </li>
                            <li>
                                <a href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=en" target="_blank">
                                    • Chrome
                                </a>
                            </li>
                            <li>
                                <a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac" target="_blank">
                                    • Safari
                                </a>
                            </li>
                            <li>
                                <a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank">
                                    • Opera
                                </a>
                            </li>
                        </ul>
                        <p>{t("5_COOKIE_CONFIGURATION.SECTION_2")}</p>
                    </section>
                    <h2>{t("6_COOKIE_POLICY_VALIDITY.HEADLINE")}</h2>

                    <section>
                        <p>{t("6_COOKIE_POLICY_VALIDITY.SECTION_1")}</p>
                        <p>{t("6_COOKIE_POLICY_VALIDITY.SECTION_2")}</p>
                    </section>
                </div>
            </AppContainer>
        </>
    );
};

export default CookiePolicy;
